import * as Joi from 'joi';

export const validatePasswordStrength = (value: string, helpers: any) => {
  let passwordStrength = 0;
  if (value.match(new RegExp('[a-z]'))) {
    passwordStrength += 1;
  }
  if (value.match(new RegExp('[A-Z]'))) {
    passwordStrength += 1;
  }
  if (value.match(new RegExp('\\d'))) {
    passwordStrength += 1;
  }
  if (value.match(new RegExp('[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>/?\\s]'))) {
    passwordStrength += 1;
  }
  if (passwordStrength >= 2) {
    return value;
  }
  return helpers.error('string.pattern.name');
};

const schema = Joi.object({
  password: Joi.string()
    .custom(validatePasswordStrength, 'Validate password strength')
    .min(12)
    .required()
    .messages({
      'any.required': 'Password is not allowed to be empty.',
      'string.empty': 'Password is not allowed to be empty.',
      'string.min': 'Password too short!',
      'string.max': 'Password too long!',
      'string.pattern.name': 'Password too weak!',
    }),
  confirmPassword: Joi.ref('password'),
}).with('password', 'confirmPassword');

export default schema;
